"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_dom_1 = require("react-dom");

var react_1 = require("react");

var hooks_1 = require("../../hooks");

var styles = tslib_1.__importStar(require("./FullScreenLoading.style"));

var loading_mrt_gif_1 = tslib_1.__importDefault(require("../../assets/loading_mrt.gif"));

function FullScreenLoading(_ref) {
  var size = _ref.size,
      _ref$appendChildren = _ref.appendChildren,
      appendChildren = _ref$appendChildren === void 0 ? false : _ref$appendChildren,
      className = _ref.className;
  hooks_1.useDialogPreventParentScroll(true);
  var LoadingAnimation = jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.root
  }, {
    children: [jsx_runtime_1.jsx("div", {
      css: styles.backdrop
    }, void 0), jsx_runtime_1.jsx("img", {
      style: {
        width: "".concat((size === null || size === void 0 ? void 0 : size.width) || 64, "px"),
        height: "".concat((size === null || size === void 0 ? void 0 : size.height) || 64, "px")
      },
      css: styles.loading,
      src: loading_mrt_gif_1.default,
      alt: "loading"
    }, void 0)]
  }), void 0);

  if (appendChildren) {
    return jsx_runtime_1.jsx(react_1.Fragment, {
      children: LoadingAnimation
    }, void 0);
  }

  return react_dom_1.createPortal(jsx_runtime_1.jsx(react_1.Fragment, {
    children: LoadingAnimation
  }, void 0), document.body);
}

exports.default = FullScreenLoading;